module.exports = __webpack_public_path__ + "img/Number=41.869698d5.png";